import { AppBar, Box, Container, Toolbar } from "@mui/material";
import ProfileIcon from '@mui/icons-material/AccountCircle';
import MyMediaIcon from '@mui/icons-material/CameraIndoor';
import FavoritesIcon from '@mui/icons-material/Favorite';
import { NavLink } from "react-router-dom";
import { PATHS } from "../../router/paths";
import NavbarMenu from "./NavbarMenu/NavbarMenu";
import NavbarMenuItem from "./NavbarMenu/NavbarMenuItem/NavbarMenuItem";
import logo from '../../logo_text.png';
import NavbarMenuButtonLogin from "./NavbarMenu/NavbarMenuButtonLogin/NavbarMenuButtonLogin";
import NavbarMenuButtonRegistration from "./NavbarMenu/NavbarMenuButtonRegistration/NavbarMenuButtonRegistration";
import NavbarMenuButtonLogout from "./NavbarMenu/NavbarMenuButtonLogout/NavbarMenuButtonLogout";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { useIsAdmin } from '../../hooks/auth/useIsAdmin';

const NavBar = () => {
	const isAdmin = useIsAdmin();
	return (
		<AppBar position="fixed" sx={{
			background: 'white',
			color: "gray"
		}} elevation={3}>
			<Container>
				<Toolbar>
					<Box sx={{ flexGrow: 1 }}>
						<NavLink to={PATHS.root}>
							<Box component="img" src={logo} alt='BlockWit' sx={{
								height: '45px',
								marginLeft: 0,
								marginRight: '20px'
							}} />
						</NavLink>
					</Box>
					<Box sx={{
						marginTop: '6px',
						flexGrow: 100
					}}>
						<NavbarMenu />
					</Box>
					<NavbarMenuButtonLogin />
					{/* <NavbarMenuButtonRegistration/> */}
					{isAdmin && <NavbarMenuItem to={PATHS.reports} icon={<AdminPanelSettingsIcon />} auth={true} />}
					{isAdmin && <NavbarMenuItem to={PATHS.manualWithdrawals} icon={<AccountBalanceWalletIcon />} auth={true} />}
					<NavbarMenuItem to={PATHS.mymedia} icon={<MyMediaIcon />} auth={true} />
					<NavbarMenuItem to={PATHS.favorites} icon={<FavoritesIcon />} auth={true} />
					<NavbarMenuItem to={PATHS.profile} icon={<ProfileIcon />} auth={true} />
					<NavbarMenuButtonLogout />
				</Toolbar>
			</Container>
		</AppBar>
	);

}

export default NavBar;